import styles from "../../styles/nature/Nature.module.css";

import MobileSearchPage from "@/components/publicProfiles/Header/MobileSearchPage";
import ProfileHeader from "@/components/publicProfiles/Header/ProfileHeader";
import BreadCrumbs from "@/components/shared/breadCrumbs/BreadCrumbs";
import { usePublicProfileContext } from "@/context/PublicProfileContext";
import ArchetypeRectangle from "@/components/traits/arcehtype/ArchetypeRectangle";
import Footers from "@/components/shared/Footers/Footers";
import TraitsSEOHeader from "@/components/traits/shared/TraitsSEOHeader";
import LargeTraitsHeading from "@/components/traits/shared/LargeTraitsHeading/LargeTraitsHeading";

export default function ArchetypeGroupHome() {
  const { mobileSearchOpen } = usePublicProfileContext();
  const data = [
    {
      slug: "personality-II",
      name: "Identity",
      color: "#55504F",
    },
    // { slug: "values", name: "Values", color: "#55504F" },
    {
      slug: "love-style",
      name: "Love",
      color: "#55504F",
    },
    { slug: "work", name: "Work", color: "#55504F" },
    { slug: "career", name: "Career", color: "#55504F" },
  ];

  return (
    <>
      <TraitsSEOHeader
        title="Dimensional || Archetype Groups"
        description="Archetypes are a special kind of trait in the Dimensional
            Personality Test. Every user unlocks one and only one Archetype
            within each Archetype group. Unlike Elements and Patterns that
            measure specific aspects of Dimensional users like Compassion or
            Assertiveness, Archetypes are a summary of a user’s Personality
            within a specific context like love or work."
      />
      {mobileSearchOpen === true && <MobileSearchPage />}
      <ProfileHeader />
      <div className={styles.main}>
        <div className={styles.top}>
          <BreadCrumbs list={["Archetypes"]} urls={[]} />
          <LargeTraitsHeading title="Archetype Groups" />
          <p className={styles.subHeading}>
            Archetypes are a special kind of trait in the Dimensional
            Personality Test. Every user unlocks one and only one Archetype
            within each Archetype group. Unlike Elements and Patterns that
            measure specific aspects of Dimensional users like Compassion or
            Assertiveness, Archetypes are a summary of a user’s Personality
            within a specific context like love or work.
            <br />
            <br />
            Archetypes will never be able to perfectly or fully capture
            someone’s personality, but they’re a helpful shorthand to learn
            about the rough outlines of another user. A foot in the door to go
            deeper.
          </p>
        </div>
        <div className={styles.parent}>
          {data.map((el, index) => {
            return (
              <ArchetypeRectangle
                color={el.color}
                name={el.name}
                slug={el.slug}
                key={index}
              />
            );
          })}
        </div>
      </div>
      <Footers />
    </>
  );
}
